import { Content } from "@iventis/translations/content/typed-content";
import React, { FunctionComponent, useMemo, useState } from "react";
import { ConfirmationDialogComponent } from "@iventis/components";
import { PeopleViewMachineEvents, PeopleViewAction } from "@iventis/people";
import { toast } from "@iventis/toasts/src/toast";
import { translate } from "@iventis/translations/translation";
import { authSlice } from "@iventis/permissions/src/auth.slice";
import { useDispatch } from "react-redux";
import { getConfirmationDialogContent } from "./people-view.helpers";

interface PeopleViewConfirmationProps {
    action: PeopleViewAction;
    setAction: (action: PeopleViewAction) => void;
    projectId: string;
    selectUserIds: string[];
    send: (event: PeopleViewMachineEvents) => void;
}

const PeopleViewConfirmation: FunctionComponent<PeopleViewConfirmationProps> = ({ action, setAction, projectId, selectUserIds, send }) => {
    const dispatch = useDispatch();
    const content = useMemo(
        () =>
            getConfirmationDialogContent(action, send, {
                onRemovePeople: (userIds) => dispatch(authSlice.actions.setUsage({ usage: "adjustUsers", adjustment: -userIds.length })),
            }),
        [action]
    );
    const [saving, setSaving] = useState(false);
    const handleConfirmation = () => {
        setSaving(true);
        content
            .apiCall(selectUserIds, projectId)
            .then(() => {
                content.callBack?.(selectUserIds);
                setAction(null);
                toast.success({ title: translate(Content.common.success), message: content.toast, testId: content.toastTestId });
                setSaving(false);
            })
            .catch(() => {
                setAction(null);
                setSaving(false);
            });
    };

    return (
        <ConfirmationDialogComponent
            show={action != null}
            handleConfirm={handleConfirmation}
            handleCancel={() => setAction(null)}
            title={content.title}
            titleIcon={content.icon}
            confirmText={translate(Content.common.buttons.continue)}
            cancelText={translate(Content.common.buttons.cancel)}
            isSubmitting={saving}
        >
            {content.message.map((text) => (
                <span key={text}>{text}</span>
            ))}
        </ConfirmationDialogComponent>
    );
};

export default PeopleViewConfirmation;
